import * as yup from 'yup';

export const commonRequestServiceCodeValidation: { [x: string]: any; } = {
    serviceRequestCode: yup.string().required("Missing."),
    subServiceRequestCode: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createRequestServiceCodeValidation: { [x: string]: any; } = {
    ...commonRequestServiceCodeValidation,
};

export const createRequestServiceCodeValidationSchema = yup.object().shape(createRequestServiceCodeValidation);

